import * as React from 'react';

import EnterpriseLearningPathDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseLearningPathDataProvider';
import SkillPathwayDataProvider from 'bundles/enterprise-learning-path-description-page/providers/SkillPathwayDataProvider';
import EnterpriseDescriptionPageDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseDescriptionPageDataProvider';

// Within EnterpriseLearningPathPageDirector, which decides whether to show the skill pathway or learning path page variants,
// we need data from the below calls to make this decision. So pulling data calls out of page roots and wrapping it around director component.
const CommonLearningPathDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseDescriptionPageDataProvider>
      <EnterpriseLearningPathDataProvider>
        <SkillPathwayDataProvider>{children}</SkillPathwayDataProvider>
      </EnterpriseLearningPathDataProvider>
    </EnterpriseDescriptionPageDataProvider>
  );
};

export default CommonLearningPathDataProvider;
